var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSocial = function SvgSocial(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFBC3B",
    d: "M11.667 7.333a4.333 4.333 0 1 0 0 8.667 4.333 4.333 0 0 0 0-8.667m2.466 3.454-2.098 2.8a1.2 1.2 0 0 1-.882.481h-.088a1.2 1.2 0 0 1-.853-.357L9.133 12.63a.667.667 0 0 1 .943-.943l.847.846a.165.165 0 0 0 .25-.018l1.897-2.529a.667.667 0 1 1 1.067.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00C1EB",
    d: "M3.05 7.313a4.98 4.98 0 0 1 4.429.472.333.333 0 0 1 .076.494 5.3 5.3 0 0 0-1.134 2.447.33.33 0 0 1-.328.274H.333a.333.333 0 0 1-.321-.429 4.98 4.98 0 0 1 3.037-3.258zM4.666 0a3.333 3.333 0 1 1 0 6.667 3.333 3.333 0 0 1 0-6.667m-1.44 2.639a.333.333 0 0 0-.494.2 2 2 0 0 0-.066.494 2 2 0 0 0 3.972.33.333.333 0 0 0-.38-.376 4 4 0 0 1-.619.046 4.64 4.64 0 0 1-2.413-.694"
  }))));
};
export default SvgSocial;